import React, { useEffect, useState } from "react";

const TypingPlaceholder = ({ texts }) => {
    const [placeholderText, setPlaceholderText] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [textIndex, setTextIndex] = useState(0);

    useEffect(() => {
        const currentText = texts[textIndex];
        const typingSpeed = isDeleting ? 50 : 100;

        const timer = setTimeout(() => {
            if (!isDeleting && currentIndex < currentText.length) {
                setPlaceholderText(currentText.slice(0, currentIndex + 1));
                setCurrentIndex(currentIndex + 1);
            } else if (isDeleting && currentIndex > 0) {
                setPlaceholderText(currentText.slice(0, currentIndex - 1));
                setCurrentIndex(currentIndex - 1);
            } else if (!isDeleting && currentIndex === currentText.length) {
                setTimeout(() => setIsDeleting(true), 2000);
            } else if (isDeleting && currentIndex === 0) {
                setIsDeleting(false);
                setTextIndex((textIndex + 1) % texts.length);
            }
        }, typingSpeed);

        return () => clearTimeout(timer);
    }, [currentIndex, isDeleting, textIndex, texts]);

    return <>Find {placeholderText}</>;
};

export default TypingPlaceholder;